import { FetchAdminUsersRequest, FetchAdminUsersResponse } from "./types";
import axios from "@/api/axiosInstance";

export const fetchAdminUsers = async (
  requestData: FetchAdminUsersRequest,
): Promise<FetchAdminUsersResponse> => {
  const response = await axios.get<FetchAdminUsersResponse>(
    "/api/private/admin/employees",
    {
      params: requestData,
    },
  );
  return response.data;
};
